import React from "react";
// import './TestCr.css';
import "./TestCr.css";
// import { FAQ } from '../Covid19/Data/FAQData'
import FaqAccorComponent from "./FaqAccorComponent";

const FAQ = [
  {
    id: 1,
    title: "What does Redcliffe Labs do? ",
    desc:
      "Redcliffe Labs is a specialized clinical laboratory where tests are carried out on medical samples to get information about a patient's health for providing precise diagnosis, treatment, and prevention of certain diseases. It is where lab tests are conducted on clinical specimens (also known as a patient sample), such as blood or urine, and the results are analyzed.",
  },
  {
    id: 2,
    title:
      " What is the procedure to book a health package test from Redcliffe Labs?",
    desc:
      "Redcliffe Labs offers you the fastest way to book a health package test. Here are the simple steps to book a health package test: Visit www.redcliffelabs.com -> Click on Book Now -> Fill your details in the 'Fill Up Form' section -> Enter (Phone,Name,City) ",
  },
  {
    id: 3,
    title: "  What Makes Redcliffe Labs a Better Pathology Lab than others? ",
    desc:
      "For us, precision care, safe sample collection, timely delivery of reports, and precise reporting of patient results while adhering to health and safety precautions are the cornerstone of our success. ",
  },
  {
    id: 4,
    title: "How much does a full body checkup cost?",
    desc:
      "The basic cost of a full body checkup at Redcliffe Labs starts at Rs. 699 including the following tests:Complete Hemogram,  Thyroid Tests, Urine Routine & Microscopy, Liver Function Tests , Kidney Function Tests, Lipid Profile Tests ,Apart from this, other health checkups are offered at Redcliffe Labs that include tests to check for other organs and diseases. Depending upon the severity of the patient's medical conditions, a full body checkup may cost up to Rs. 4999. ",
  },
  {
    id: 5,
    title: "Why opt for a full-body test from Redcliffe Labs?",
    desc:
      "Getting a whole-body checkup from Redcliffe Labs includes health checkups that include tests for diabetes, thyroid, cholesterol, blood pressure, and other medical conditions to prevent future health issues.",
  },
  {
    id: 6,
    title: "Does Redcliffe Labs provide home sample collection? ",
    desc:
      "Yes. Redcliffe Labs provides home sample collection by following the required safety measures and protocols. ",
  },
  {
    id: 7,
    title: "Who can get tested by Redcliffe Labs?",
    desc:
      "Redcliffe Labs full body health checkup helps people keep a check on what's going on inside their bodies. Regular health checkups are important to people ranging between 30-40 years of age to get their full-body checkups every two years. Colorectal cancer screening, blood pressure screening and cholesterol screening tests are also offered at Redcliffe Labs specialized labs for people ageing between 40 and 60 years of age. For people above 60 years or above and experiencing certain health conditions, regular health checkups should be done at least once a year. ",
  },
  {
    id: 8,
    title: " Which is the best test for the whole body?",
    desc:
      "Some of the popular tests for whole body checkups are: RBC count , Platelet count , Haemoglobin , ESR, HbA1C, Creatinine, Uric Acid , Total Cholesterol, Total Protein and others",
  },
  {
    id: 9,
    title: " What precautions can be taken before a health checkup?",
    desc:
      "Patients are asked to have their food at least 8-10 hours before health checkups as some tests are done on an empty stomach and require fasting of at least 8-10 hours.",
  },
  {
    id: 10,
    title: "Can I drink water before my full body checkup test?",
    desc:
      "Patients are asked not to eat or drink anything for at least 8-10 hours if they plan to go for a full body checkup test. The patient can take water in some cases to reduce the chances of dehydration. ",
  },
];

const TestCr = ({ faq }) => {
  // console.log("from parent",faq);
  return (
    <React.Fragment>
      {faq !== ""? (
        <div className="accordionNew" id="faq">
          <h1 className="h1style"> Frequently Asked Questions</h1>

          {faq?.map((ele) => (
            <FaqAccorComponent value={ele} />
          ))}
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default TestCr;
